import { ENDPOINTS } from "config/endpoints";
import { useMutation, useQueryClient } from "react-query";
import Error from "types/error";
import client from "utils/client";
import { Request } from "types/request";
import { Response } from "types/response";
import { Contact } from "types/user";
import { generatePath } from "react-router-dom";

interface DeclineFriendshipRequestInfo {
  requestId: string;
}

export default function useDeclineFriendshipRequest() {
  const queryClient = useQueryClient();

  const acceptFriendshipRequest = (data: DeclineFriendshipRequestInfo) => {
    const { requestId } = data;
    const request: Request = {
      url: generatePath(ENDPOINTS.friendshipRequest.decline, { id: requestId }),
      config: {
        method: "patch",
      },
    };
    return client(request);
  };

  const { data, mutate, ...rest } = useMutation<
    Response<Contact>,
    Error,
    DeclineFriendshipRequestInfo
  >(acceptFriendshipRequest, {
    onSettled: (data, error, variables) => {
      queryClient.invalidateQueries([ENDPOINTS.friendshipRequest.received]);
    },
  });

  return { data, mutate, ...rest };
}
